export default {"src":"/org/_next/static/media/running.cdfa24e3.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};